import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAdmin } from "../../context/AdminContext.js";
import "./Admin.css";

const AdminLogin = () => {
  const { admin, login, verifyTwoFactor } = useAdmin();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("credentials");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (admin) {
    return <Navigate to={location.state?.from || "/admin/quote-leads"} replace />;
  }

  const handleCredentialsSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const result = await login(email, password);
      if (result.requiresTwoFactor) {
        setStep("twoFactor");
      } else {
        navigate("/admin/quote-leads", { replace: true });
      }
    } catch (err) {
      setError(err.response?.data?.error || "Invalid email or password.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleTwoFactorSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await verifyTwoFactor(code);
      navigate("/admin/quote-leads", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Invalid verification code.");
    } finally {
      setSubmitting(false);
    }
  };

  if (step === "twoFactor") {
    return (
      <div className="admin-login-page">
        <form className="admin-login-card" onSubmit={handleTwoFactorSubmit}>
          <h1>Two-Factor Verification</h1>
          <p className="admin-login-subtitle">
            Enter the 6-digit code from your authenticator app, or one of your backup codes.
          </p>

          <div className="admin-form-group">
            <label htmlFor="admin-2fa-code">Verification code</label>
            <input
              id="admin-2fa-code"
              type="text"
              inputMode="text"
              autoComplete="one-time-code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="123456 or XXXX-XXXX"
              autoFocus
              required
            />
          </div>

          {error && <p className="admin-error">{error}</p>}

          <button type="submit" disabled={submitting}>
            {submitting ? "Verifying…" : "Verify"}
          </button>
          <button
            type="button"
            className="admin-login-back-btn"
            onClick={() => {
              setStep("credentials");
              setCode("");
              setError("");
            }}
          >
            Back to sign in
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="admin-login-page">
      <form className="admin-login-card" onSubmit={handleCredentialsSubmit}>
        <h1>Aeti Admin</h1>
        <p className="admin-login-subtitle">Sign in to manage quote leads and bookings.</p>

        <div className="admin-form-group">
          <label htmlFor="admin-email">Email</label>
          <input
            id="admin-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
        </div>

        <div className="admin-form-group">
          <label htmlFor="admin-password">Password</label>
          <input
            id="admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        {error && <p className="admin-error">{error}</p>}

        <button type="submit" disabled={submitting}>
          {submitting ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
